import React from "react";
import PropTypes from "prop-types";
import DoubleContentImageStyled from "./ContentWithImage.Style";
import Image from "../Image";
import DoubleContent from "../DoubleContent";

const ContentWithImage = ({
  imgSrc,
  imgAlt,
  image,
  imgColumnSize,
  reverse,
  children,
  hideMobile,
  className,
}) => {
  const imageContent = image ? (
    React.cloneElement(image, { className: "ContentWithImage__Image" })
  ) : (
    <Image
      className="ContentWithImage__Image"
      src={imgSrc}
      alt={imgAlt}
      title={imgAlt}
    />
  );
  return (
    <DoubleContentImageStyled
      as={DoubleContent}
      collumnSize={imgColumnSize}
      leftContent={imageContent}
      reverse={reverse}
      hideMobile={hideMobile}
      className={className}
    >
      {children}
    </DoubleContentImageStyled>
  );
};

ContentWithImage.defaultProps = {
  imgSrc: null,
  imgAlt: null,
  image: null,
  imgColumnSize: 4,
  reverse: false,
  hideMobile: true,
};

ContentWithImage.propTypes = {
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  imgColumnSize: PropTypes.number,
  image: (props, propName, componentName) => {
    const { imgSrc, [propName]: imageValue } = props;
    if (!imgSrc && !imageValue) {
      return new Error(
        `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`
      );
    }
    return null;
  },
  reverse: PropTypes.bool,
  hideMobile: PropTypes.bool,
};

export default ContentWithImage;
